import React from "react";
import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { gettrippass } from "../../../services/TransportService";
import { FaUserGroup } from "react-icons/fa6";
const Trippass = ({ id, passdata, setPassdata }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!passdata) {
      setLoading(true);
      gettrippass(id)
        .then((res) => {
          setPassdata(res?.data?.results);
        })
        .catch((err) => {
          setError(
            err?.response?.data?.message ||
              err?.response?.data?.error ||
              "Try again later"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);
  if (loading) {
    return (
      <div className="text-center">
        <Spinner animation="border" className="mt-3" />
      </div>
    );
  }
  return (
    <>
      {error ? (
        <div className="alert alert-danger">{error}</div>
      ) : passdata?.length != 0 ? (
        <>
          <div className="mb-2">
            <span
              className="offcanvas-title fw-semibold text-dark"
              style={{ fontSize: "1rem" }}
            >
              Total Employees
            </span>
            <badge className="badge bg-primary ms-2">
              <FaUserGroup /> {passdata?.length || "NA"}
            </badge>
          </div>
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="bg-light custom-thead">
                <tr>
                  <th>Pass ID</th>
                  <th>Name</th>
                  <th>Stop</th>
                </tr>
              </thead>
              <tbody>
                {passdata?.map((item) => (
                  <tr>
                    <td>{item?.pass_id || "N/A"}</td>
                    <td>{item?.employee?.name || "N/A"}</td>
                    <td>{item?.stop || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="text-center my-2">No Pass Found</div>
      )}
    </>
  );
};

export default Trippass;
